package com.tovtalk.utils.orientation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect

@Composable
actual fun LockPortraitOrientation() {
    DisposableEffect(Unit) {
        // Best-effort portrait lock via the Screen Orientation API.
        // Only works on supported browsers and while in fullscreen on some of
        // them - failures are swallowed silently.
        try {
            val orientation = js("screen.orientation")
            if (orientation != null && orientation.lock != null) {
                orientation.lock("portrait")
            }
        } catch (_: Throwable) {
            // ignored
        }
        onDispose {
            try {
                val orientation = js("screen.orientation")
                if (orientation != null && orientation.unlock != null) {
                    orientation.unlock()
                }
            } catch (_: Throwable) {
                // ignored
            }
        }
    }
}
